import Signal from '@/webgl/core/Signal'
import AnimationSequence from '@/webgl/runner/animations/AnimationSequence'
import ClearColorAnimation from '@/webgl/runner/animations/ClearColorAnimation'
import EyeRevealAnimation from '@/webgl/runner/animations/EyeRevealAnimation'
import LanesRevealAnimation from '@/webgl/runner/animations/LanesRevealAnimation'
import PlayerRevealAnimation from '@/webgl/runner/animations/PlayerRevealAnimation'
import RailsRevealAnimation from '@/webgl/runner/animations/RailsRevealAnimation'
import SmokeRevealAnimation from '@/webgl/runner/animations/SmokeRevealAnimation'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import PostprocessSystem from '@/webgl/runner/systems/PostprocessSystem'
import ScrollSystem from '@/webgl/runner/systems/ScrollSystem'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

export class Outro implements IGameSegment {
  outro: AnimationSequence
  onComplete = new Signal<void>()
  world: GameWorld

  constructor(
    readonly id: string,
    readonly scrollingItems: string[] = []
  ) {}

  init(world: GameWorld, renderer: IRunnerRenderer, setup: ScenarioSetup) {
    this.world = world
    this.outro = new AnimationSequence()
    this.outro.add(
      new LanesRevealAnimation(renderer.lanes, {
        reverse: true,
        laneLength: this.world.settings.LANE_LENGTH,
        duration: 1.5,
        delay: 0.4,
      })
    )

    this.outro.add(new RailsRevealAnimation(renderer.rails, { reverse: true }))
    this.outro.add(new EyeRevealAnimation(renderer.eye, { reverse: true, delay: 0.4 }))
    this.outro.add(new PlayerRevealAnimation(renderer.player, { reverse: true }))
    this.outro.add(new SmokeRevealAnimation(renderer.smoke, { reverse: true, duration: 0.6 }))
    this.outro.add(new ClearColorAnimation(renderer.glRenderer, { targetColor: 0xfff4e5 }))
  }

  async start() {
    this.world.destroyAllCollectibles()
    this.world.systems.get<ScrollSystem>(ScrollSystem).stop()
    this.world.systems.get<PostprocessSystem>(PostprocessSystem).disableFreeze()
    this.world.state.alterJauge(-1)

    this.outro.init()
    this.outro.play().then(() => this.onComplete.emit(null))
  }

  stop(): void {
    this.onComplete.release()
  }
}
